export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11871.aec58f67.jpg";